import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { TimesheetRecord } from "../../../data/types"
import { AddShiftBreakData } from "./timesheets/AddShiftModal"
import { TimeRecordCreateBreakData } from "../../../../events/TimeRecordBreak/types"
import { RoleDTO } from "../../employees/positions/types"

export type TimesheetPopoverClickedParams = {
    timeRecord?: Maybe<TimesheetRecord>
    userAccountId: string
    clockInLocationId: string
    clockInTimestamp: Maybe<Date>
    clockOutLocationId: Maybe<string>
    clockOutTimestamp: Maybe<Date>
    roleId: Maybe<string>
    breaks?: Maybe<TimeRecordCreateBreakData[]>
    editingId?: string
}

export type TimesheetPopoverBreaksData = {
    paidBreaks: AddShiftBreakData[]
    unpaidBreaks: AddShiftBreakData[]
}

export const CLEAR_TIMESHEET_DATA = "timesheet/clearData"

export const clearTimesheetData = () => ({
    type: CLEAR_TIMESHEET_DATA,
})

export const ADD_EMPLOYEE_SHIFTS = "employee/addShifts"

export const addEmployeeShifts = (userAccountId: string) => ({
    type: ADD_EMPLOYEE_SHIFTS,
    payload: {
        userAccountId: userAccountId,
    },
})

export const ADD_SHIFT_MODAL_OPENED = "addShiftModal/opened"

export const addShiftModalOpened = (userAccountId: Maybe<string>) => ({
    type: ADD_SHIFT_MODAL_OPENED,
    payload: {
        userAccountId: userAccountId,
    },
})

export const EDIT_SHIFT_MODAL_OPENED = "editShiftModal/opened"

export const editShiftModalOpened = (shiftDetail: Maybe<TimesheetRecord>) => ({
    type: EDIT_SHIFT_MODAL_OPENED,
    payload: {
        shiftDetail: shiftDetail,
    },
})

export const TIMESHEET_AGENDA_MOUNTED = "timesheet/mounted"

export const timesheetAgendaMounted = () => ({
    type: TIMESHEET_AGENDA_MOUNTED,
})

export const CLOCK_IN_OUT_POPOVER_CONFIRM_CLICKED = "clockInOutPopover/confirmClicked"

export const clockInOutPopoverConfirmClicked = (params: TimesheetPopoverClickedParams, roles: RoleDTO[]) => ({
    type: CLOCK_IN_OUT_POPOVER_CONFIRM_CLICKED,
    payload: {
        params: params,
        roles: roles,
    },
})

export const TIMESHEET_REQUEST_SUCCESS = "timesheet/request/success"
export const timesheetRequestSuccess = () => ({
    type: TIMESHEET_REQUEST_SUCCESS,
})

export const TIMESHEET_REQUEST_FAILED = "timesheet/request/failed"
export const timesheetRequestFailed = () => ({
    type: TIMESHEET_REQUEST_FAILED,
})

export const FETCH_TIMESHEET_REPORT_SUCCESS = "timesheet/success"
export const fetchTimesheetReportSuccess = () => ({
    type: FETCH_TIMESHEET_REPORT_SUCCESS,
})
